export default class AbstractTextFormatter {
  regEx: any
  constructor(regEx: any) {
    this.regEx = regEx
  }

  internalFormat() {}

  format(text: any) {
    let matches
    let formattedResult = text

    while ((matches = this.regEx.exec(text)) != null) {
      // @ts-expect-error
      formattedResult = formattedResult.replace(matches[0], this.internalFormat(matches))
    }

    return formattedResult
  }
}
